import axios from 'axios';

export const toggleQuestionnaireApiAccess = async (questionnaireId, tenantId, enabled, getState) => {
    const state = getState();
    const jwtToken = state.authData?.[0]?.signInUserSession?.accessToken?.jwtToken;

    if (!jwtToken) {
        throw new Error('Not authenticated');
    }

    const headers = {
        Authorization: `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
    };

    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/toggle-questionnaire-api`,
        { questionnaireId, tenantId, enabled },
        { headers }
    );
    return response.data;
};

export const getTenantApiToken = async (getState) => {
    const state = getState();
    const jwtToken = state.authData?.[0]?.signInUserSession?.accessToken?.jwtToken;
    const tenantName = state.tenantManagement?.activeTenant?.name;

    if (!jwtToken) {
        throw new Error('Not authenticated');
    }

    const headers = {
        Authorization: `Bearer ${jwtToken}`
    };

    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/get-tenant-api-token?tenantId=${tenantName}`,
        { headers }
    );
    return response.data;
};

export const regenerateTenantToken = async (getState) => {
    const state = getState();
    const jwtToken = state.authData?.[0]?.signInUserSession?.accessToken?.jwtToken;
    const tenantName = state.tenantManagement?.activeTenant?.name;

    if (!jwtToken) {
        throw new Error('Not authenticated');
    }

    const headers = {
        Authorization: `Bearer ${jwtToken}`
    };

    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/regenerate-tenant-api-token`,
        { tenantId: tenantName },
        { headers }
    );
    return response.data;
};
